<template>
    <Transition name="success-transition">
        <div class="success-box" v-if="successMessage">{{ successMessage }}</div>
      </Transition>
    <div class="container">
            <o-bread-crumb>
                <template v-slot:pageName>
                    Merchant
                </template>
                <template v-slot:pageDetail>
                    {{ page.cardTitle }}
                </template>
            </o-bread-crumb>
            <div v-if="error" class="alert alert-danger" role="alert">
                {{ error }}
            </div>
            <div class="d-flex justify-content-">
                <o-card :card-title="page.cardTitle" class="custom-table mw-700">
                    <o-form @submit.prevent="change()" autocomplete="off">
                        <o-form autocomplete="off">
                            <div class="d-flex justify-content-between me-2">
                                <div class="col-md-6 me-2">
                                    <o-form-group title="code" name="code">
                                        <span class="text-danger"> *</span>
                                        <o-input-text name="code" v-model="merchant.code" type="text" :required="true" :autocomplete="'off'"/>
                                            <div v-if="validation.code">
                                                <div class="alert alert-danger mt-1" role="alert">
                                                    {{ validation.code[0] }}
                                                </div>
                                            </div>
                                    </o-form-group>
                                </div>
                                <div class="col-md-6">
                                    <o-form-group title="name" name="name">
                                        <span class="text-danger"> *</span>
                                        <o-input-text name="name" :autocomplete="'off'" v-model="merchant.name" type="text" :required="true"/>
                                        <div v-if="validation.name">
                                            <div class="alert alert-danger mt-1" role="alert">
                                                {{ validation.name[0] }}
                                            </div>
                                        </div>
                                    </o-form-group>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between me-2">
                                <div class="col-md-6 me-2">
                                    <o-form-group title="city/area" name="city">
                                        <span class="text-danger"> *</span>
                                        <o-input-text name="city" v-model="merchant.city" type="text" :required="true" autocomplete="'off'"></o-input-text>
                                        <div v-if="validation.city">
                                            <div class="alert alert-danger mt-1" role="alert">
                                                {{ validation.city[0] }}
                                            </div>
                                        </div>
                                    </o-form-group>
                                </div>
                                <div class="col-md-6">
                                    <o-form-group title="state/province" name="state">
                                        <span class="text-danger"> *</span>
                                        <o-input-text name="state" v-model="merchant.state" type="text" :required="true" autocomplete="'off'"/>
                                        <div v-if="validation.state">
                                            <div class="alert alert-danger mt-1" role="alert">
                                                {{ validation.state[0] }}
                                            </div>
                                        </div>
                                    </o-form-group>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between me-2">
                                <div class="col-md-6 me-2">
                                    <o-form-group title="post code" name="postcode">
                                        <span class="text-danger"> *</span>
                                        <o-input-text name="postcode" v-model="merchant.postcode" type="text" autocomplete="'off'"></o-input-text>
                                        <div v-if="validation.postcode">
                                            <div class="alert alert-danger mt-1" role="alert">
                                                {{ validation.postcode[0] }}
                                            </div>
                                        </div>
                                    </o-form-group>
                                </div>
                                <div class="col-md-6">
                                    <o-form-group title="country" name="country">
                                        <span class="text-danger"> *</span>
                                        <o-select v-model="merchant.country" :options="options" autocomplete="'off'"></o-select>
                                        <div v-if="validation.country">
                                            <div class="alert alert-danger mt-1" role="alert">
                                                {{ validation.country[0] }}
                                            </div>
                                        </div>
                                    </o-form-group>
                                </div>
                            </div>
                            <o-form-group title="address" name="address">
                                <o-textarea 
                                    name="address"
                                    v-model="merchant.address"
                                    placeholder="enter your additioal address information"
                                    style="height: 45px"
                                    for="address"
                                    id="address"
                                    autocomplete="'off'"
                                ></o-textarea>
                                <div v-if="validation.address">
                                    <div class="alert alert-danger mt-1" role="alert">
                                        {{ validation.address[0] }}
                                    </div>
                                </div>
                            </o-form-group>
                            <div class="d-flex justify-content-between me-2">
                                <div class="col-md-6 pe-2">
                                    <o-form-group title="phone" name="phone">
                                        <span class="text-danger"> *</span>
                                        <div class="d-flex">
                                            <div style="width: 25%;" v-if="!unknownCountry">
                                              <o-input-text
                                                name="countryCode"
                                                :autocomplete="'off'"
                                                v-model="countryCode"
                                                type="text"
                                                :required="true"
                                                :readonly="true"
                                                :disabled="true"
                                              />
                                            </div>
                                            <div style="width: 100%;">
                                              <o-input-text
                                                name="phone"
                                                :autocomplete="'off'"
                                                v-model="merchant.phone"
                                                type="text"
                                                :required="true"
                                                :numbers-only="true"
                                              />
                                            </div>
                                          </div>
                                        <div v-if="validation.phone">
                                          <div class="alert alert-danger mt-1" role="alert">
                                            {{ validation.phone[0] }}
                                          </div>
                                        </div>
                                      </o-form-group>
                                </div>
                                <div class="col-md-6">
                                    <o-form-group title="fax" name="fax">
                                        <o-input-text mask="fax" name="fax" v-model="merchant.fax" type="text" autocomplete="'off'"/>
                                        <div v-if="validation.fax">
                                            <div class="alert alert-danger mt-1" role="alert">
                                                {{ validation.fax[0] }}
                                            </div>
                                        </div>
                                    </o-form-group>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between me-2">
                                <div class="col-md-6 me-2">
                                    <o-form-group title="website url" name="website">
                                        <o-input-text name="website" v-model="merchant.website" type="text" autocomplete="'off'"/>
                                        <div v-if="validation.website">
                                            <div class="alert alert-danger mt-1" role="alert">
                                                {{ validation.website[0] }}
                                            </div>
                                        </div>
                                    </o-form-group>
                                </div>
                                <!-- <div class="col-md-6">
                                    <o-form-group v-if="!showPropertyCode" title="commerce site" name="commerce">
                                      <o-input-text name="commerce" v-model="merchant.commerce_site" type="text" :required="true" autocomplete="'off'"/>
                                      <div v-if="validation.commerce_site">
                                        <div class="alert alert-danger mt-1" role="alert">
                                          {{ validation.commerce_site[0] }}
                                        </div>
                                      </div>
                                      <button v-if="!merchant.commerce_site && !bookingEngineMode" @click="showPropertyCode = true; bookingEngineMode = true" class="btn btn-secondary mb-2">Booking Engine</button>
                                      <div class="input-container">
                                        <o-input-text
                                          v-if="merchant.commerce_site && !showPropertyCode && bookingEngineMode"
                                          v-model="commerce_site_change"
                                          :required="false"
                                          type="text"
                                          autocomplete="'off'"
                                          class="input-small"
                                        />
                                        <button
                                          v-if="merchant.commerce_site && bookingEngineMode"
                                          @click="reGenerateCommerceSite"
                                          :disabled="!commerce_site_change"
                                          class="btn btn-secondary mb-2"
                                        >
                                          Change
                                        </button>
                                      </div>
                                    </o-form-group>
                                    
                                    <div v-if="showPropertyCode && bookingEngineMode">
                                      
                                      <div>
                                        <o-form-group title="Property Code" name="property_code">
                                          <span class="text-danger"> *</span>
                                          <o-input-text name="property_code" v-model="propertyCode" type="text" :required="true" autocomplete="'off'"/>
                                        </o-form-group>
                                
                                        <button @click="generateCommerceSite" :disabled="!propertyCode" class="btn btn-primary">Generate</button>
                                
                                        <div v-if="!propertyCode && generateClicked">
                                          <div class="alert alert-danger mt-1" role="alert">
                                            Property code cannot be empty.
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div> -->
                            </div>
                            <o-form-group title="logo" name="logo">
                                <!-- <span class="text-danger"> *</span> -->
                                <o-image-input name="logo" id="logo" :imageurl="image.url" @selectImage="imageHandling"></o-image-input>
                                <div v-if="validation.logo">
                                    <div class="alert alert-danger mt-1" role="alert">
                                        {{ validation.logo[0] }}
                                    </div>
                                </div>
                            </o-form-group>
                        </o-form>
                        <div class="d-flex justify-content-center spinner-border text-primary spinner-position form" v-if="page.isLoading"></div>
                        <div class="spinner" v-if='page.isLoading'></div>
                        <div class="button-container mt-3">
                            <o-button :disabled='isLoading' type="submit" :size="'sm'" :variant="'primary'" :white="'white'">
                                Save
                            </o-button>
                            <o-button @click="cancel()" :size="'sm'" :variant="'outline-secondary'" :white="'white'">
                                Cancel
                            </o-button>
                        </div>
                    </o-form>
                </o-card>
            </div>
    </div>
</template>

<script>
import { OCard, OForm, OFormGroup, OInputText, OButton, OTextarea, OSelect, OImageInput, OBreadCrumb } from '@/components/OmnihControl';
import { reactive, ref, onMounted, computed, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import store from '@/store/'
import { isSupportedCountry, getCountryCallingCode } from 'libphonenumber-js';
import { getCode } from 'country-list';

export default {
name: 'Addmerchant',
components: {
    OCard,
    OForm,
    OFormGroup,
    OInputText,
    OButton,
    OTextarea,
    OSelect,
    OImageInput,
    OBreadCrumb
},
setup(){
    const page = reactive({
        isLoading: false,
        cardTitle: 'Create Merchant'
    })

    const merchant = reactive({
        code: '',
        name: '',
        logo: '',
        address: '',
        state: '',
        country: 0,
        phone: '',
        fax: '',
        branch_id: '',
        website: '',
        commerce_site: '',
        city: '',
        postcode: ''
    });
    const successMessage = ref('');
    const showPropertyCode = ref(false);

    const bookingEngineApi = ref('');
    const commerce_site_change = ref('');
    const bookingEngineMode = ref(false);
    const propertyCode = ref('');
    const generateClicked = ref(false);

    const isCommerceSiteNull = computed(() => {
        return merchant.commerce_site === null || merchant.commerce_site === '';
    });
    const image = reactive({
        url: ''
    })

    const options = ref([]);

    const validation = ref([]);
    const error = ref('');
    const router = useRouter();

    const route = useRoute();

    const selectedBusinessProfile = reactive({
        corporate_id: "",
        branch_id: "",
    });

    const countryCode = ref('');

    const unknownCountry = ref(false);

    const countries = ref([]);

    const merchantCountry = ref();

    onMounted(async () => {
        page.isLoading = true;

        await loadCountries();

        if (route.params.id) {
            await loadState(route.params.id);
        }
        store.dispatch('Publics/get_booking_engine_api').then((data) => {
            bookingEngineApi.value = data;
        })

        loadBranch();
        updatePhoneCode();

        page.isLoading = false;
    });

    async function loadCountries() {
        try {
            const response = await store.dispatch('Countries/read');
            countries.value = response.map(country => ({ value: country.id, text: country.name }));
            options.value = countries.value;
            if (countries.value.length > 0) {
                await loadBranch();
            }
        } catch (err) {
            console.error(err);
        }
    }

    async function loadBranch() {
        store.dispatch('Auth/getBusinessProfile').then((business_profile) => {
            merchant.branch_id = business_profile.branch_id;
        });
    }

    async function loadState(id) {
        try {
            const data = await store.dispatch('Merchant/read_single', id);
            page.cardTitle = 'Edit Merchant';

            merchant.country = data.business_profile.country;
            merchant.id = data.id;
            merchant.branch_id = data.branch_id;
            merchant.code = data.code;
            merchant.name = data.name;
            merchant.address = data.business_profile.address;
            merchant.state = data.business_profile.state;
            merchant.phone = removeCountryCode(data.business_profile.phone);
            merchant.fax = data.business_profile.fax;
            merchant.website = data.business_profile.website;
            merchant.commerce_site = data.business_profile.commerce_site;
            merchant.city = data.business_profile.city;
            merchant.postcode = data.business_profile.postcode;

            image.url = data.business_profile.logo.image_url;
        } catch (error) {
            console.error('Error loading state:', error);
        }
    }

    function updatePhoneCode() {
        if (!countries.value || countries.value.length === 0) {
            console.error('Countries data is not loaded yet.');
            return;
        }
        
        const countryName = countries.value.find(country => country.value === parseInt(merchant.country));
        
        if (countryName) {
            merchantCountry.value = countryName;
            const code = getCode(merchantCountry.value.text);
            if (isSupportedCountry(code)) {
                unknownCountry.value = false;
                const phoneCode = getCountryCallingCode(code);
                if (phoneCode) {
                    countryCode.value = `+${phoneCode} `;
                }
            } else {
                unknownCountry.value = true;
                console.error(`Unknown country: ${merchantCountry.value.text}`);
            }
        } else {
            unknownCountry.value = true;
            console.error(`Country not found for merchant country: ${merchant.country}`);
        }
    }

    function removeCountryCode(phone) {
        const countryName = countries.value.find(country => country.value === parseInt(merchant.country));
        if (countryName) {
            merchantCountry.value = countryName;
            const code = getCode(merchantCountry.value.text);
            if (isSupportedCountry(code)) {
                unknownCountry.value = false;
                const phoneCode = getCountryCallingCode(code);
                if (phoneCode) {
                    const countryCodePattern = new RegExp(`^\\+${phoneCode}`);
                    return phone.replace(countryCodePattern, '').trim();
                }
            } else {
                unknownCountry.value = true;
                console.error(`Unknown country: ${merchantCountry.value.text}`);
            }
        } else {
            unknownCountry.value = true;
            console.error(`Country not found for merchant country: ${merchant.country}`);
        }
        return phone;
    }

    function imageHandling(img) {
        merchant.logo = img
    }

    function change(){
        merchant.phone = (countryCode.value + merchant.phone).replace(/\s+/g, '');

        const data = {...merchant}
        page.isLoading = true;

        if(route.name != 'MerchantForm'){

            if (data.logo == '') {
                delete data.logo
            }

            store.dispatch('Merchant/update', {data}).then(() => {
                router.push({
                    name: 'Merchant',
                })
            }).catch((err) => {
                merchant.phone = removeCountryCode(merchant.phone);
                if(err.response && err.response.status === 403){
                    error.value = err.response.data.message
                }else{
                    validation.value = JSON.parse(err.response.data.error)
                    
                    if (data.country === 0 || data.country === '') {
                        validation.value.country = ['Country is required.'];
                        page.isLoading = false;
                        return; 
                    } else {
                        delete validation.value.country;
                    }
                }
            }).finally(() =>{
                page.isLoading = false
            });
        }else{
            
            store.dispatch('Merchant/create', {data}).then(() => {
                router.push({
                    name: 'Merchant',
                    query: { newMerchant: 'true' }
                })
            }).catch((err) => {
                merchant.phone = removeCountryCode(merchant.phone);

                if(err.response && err.response.status === 403){
                    error.value = err.response.data.message
                }else{
                    validation.value = JSON.parse(err.response.data.error)

                    if (data.country === 0 || data.country === '') {
                        validation.value.country = ['Country is required.'];
                        page.isLoading = false;
                        return; 
                    } else {
                        delete validation.value.country;
                    }
                }
            }).finally(() => {
                page.isLoading = false;
            });
        }
    }
    function generateCommerceSite() {
        generateClicked.value = true;

        if (propertyCode.value.trim() === '') {
            validation.value.commerce_site = ['Property code is required'];
            return;
        }

        merchant.commerce_site = `${bookingEngineApi.value}${propertyCode.value}/`;
        successMessage.value = 'Commerce Site has been generated successfully!';
        setTimeout(() => {
            successMessage.value = '';
        }, 3000);
        validation.value.commerce_site = false;
        propertyCode.value = '';
        showPropertyCode.value = false;
        generateClicked.value = false;
        bookingEngineMode.value = true;
    }
    function reGenerateCommerceSite() {
        merchant.commerce_site = `${bookingEngineApi.value}${commerce_site_change.value}/`;
        
        validation.value.commerce_site = false;
        propertyCode.value = '';
        showPropertyCode.value = false;
        generateClicked.value = false;
        commerce_site_change.value = '';
        successMessage.value = 'Commerce Site has been regenerated successfully!';
        setTimeout(() => {
            successMessage.value = '';
        }, 10000);
    }
    watch(
      () => merchant.commerce_site,
      (newValue) => {
        if (newValue === '') {
          bookingEngineMode.value = false;
        }
      }
    );

    function cancel() {
        router.push({ name: 'Merchant' });
    }

    watch(() => merchant.country, updatePhoneCode);

    return {
        merchant,
        validation,
        router,
        options,
        change,
        page,
        imageHandling,
        image,
        selectedBusinessProfile,
        propertyCode,
        generateClicked,
        generateCommerceSite,
        isCommerceSiteNull,
        showPropertyCode,
        reGenerateCommerceSite,
        bookingEngineMode,
        commerce_site_change,
        successMessage,
        countryCode,
        unknownCountry,
        countries,
        cancel,
        error
    }
}
}
</script>
<style scoped>
.input-container {
    display: flex;
    align-items: center; /* Vertically center items */
  }
  
  .input-small {
    width: 150px; /* Atur lebar input sesuai kebutuhan */
    margin-right: 10px; /* Tambahkan margin antara input dan button */
  }

  .success-box {
      position: fixed;
      top: 0;
      left: 30%;
      background-color: #d4edda;
      color: #155724;
      padding: 12px 20px;
      border-radius: 4px;
      border: 1px solid #c3e6cb;
      font-size: 14px;
      font-weight: 500;
      z-index: 9999;
  }
  
  .success-transition-enter-active,
  .success-transition-leave-active {
      transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
  }
  
  .success-transition-enter-from,
  .success-transition-leave-to {
      transform: translateY(-20%);
      opacity: 0;
  }
  
  .success-transition-enter-to,
  .success-transition-leave-from {
      transform: translateY(0);
      opacity: 1;
  }

</style>